function updateProgressiveFilters() {
    console.log("🔄 updateProgressiveFilters() fired");
  
    const filters = document.querySelectorAll("facet-fake-filter-button");
    const activeFacets = document.querySelector(".active-facets");
  
    if (!filters.length) {
      console.warn("⚠️ No filters found in DOM");
      return;
    }
  
    filters.forEach((filter, index) => {
      const button = filter.querySelector("button");
      const label = button.querySelector("span").innerText.split(" - ")[0].trim();
  
      const isActive = activeFacets && activeFacets.innerText.includes(label);
  
      console.log(`Filter ${index + 1}: label="${label}", active=${isActive}`);
  
      if (index === 0) {
        console.log("➡️ Filter 1 always enabled");
        button.removeAttribute("disabled");
        button.classList.remove("disabled");
        return;
      }
  
      const prevFilter = filters[index - 1];
      const prevLabel = prevFilter.querySelector("span").innerText.split(" - ")[0].trim();
      const prevIsActive = activeFacets && activeFacets.innerText.includes(prevLabel);
  
      console.log(`   Prev filter "${prevLabel}" active=${prevIsActive}`);
  
      if (!prevIsActive) {
        console.log(`   ❌ Blocking filter ${index + 1}`);
        button.setAttribute("disabled", true);
        button.classList.add("disabled");
      } else {
        console.log(`   ✅ Enabling filter ${index + 1}`);
        button.removeAttribute("disabled");
        button.classList.remove("disabled");
      }
    });
  }
  
  document.addEventListener("DOMContentLoaded", () => {
    console.log("📌 DOMContentLoaded fired");
    updateProgressiveFilters();
  
    const form = document.getElementById("FacetFiltersPillsForm");
  
    if (!form) {
      console.warn("⚠️ FacetFiltersPillsForm not found");
      return;
    }
  
    console.log("👀 Setting up MutationObserver on #FacetFiltersPillsForm");
  
    const observer = new MutationObserver((mutations) => {
      console.log("🔔 MutationObserver triggered");
      mutations.forEach((m, i) => {
        console.log(`   Mutation ${i}: type=${m.type}`);
      });
  
      updateProgressiveFilters();
    });
  
    observer.observe(form, {
      childList: true,
      subtree: true
    });
  });
  